var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg20IcFlow20(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.583 7.833a1.583 1.583 0 1 0 0-3.167 1.583 1.583 0 0 0 0 3.167zm0 1.333a2.917 2.917 0 1 0-2.908-3.143c-.287.036-.6.117-.903.258-.755.353-1.439 1.09-1.439 2.315 0 .357.006.67.012.963.006.329.011.633.008.947-.006.563-.046.986-.146 1.307-.093.297-.228.478-.433.603-.11.067-.258.129-.459.174a2.917 2.917 0 1 0-.177 1.377c.515-.056.959-.186 1.33-.412.538-.328.845-.808 1.012-1.345.16-.516.2-1.102.206-1.689.004-.303-.002-.66-.009-1.024-.005-.304-.01-.613-.01-.901 0-.626.306-.937.67-1.107.177-.083.369-.13.54-.148a2.918 2.918 0 0 0 2.706 1.825zM5.417 14.5a1.583 1.583 0 1 0 0-3.167 1.583 1.583 0 0 0 0 3.167z",
    fill: "#4C4C4C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg20IcFlow20);
export default __webpack_public_path__ + "static/media/20_ic_flow_20.e133fa2f4b69cfee455cfdd9143a0109.svg";
export { ForwardRef as ReactComponent };